exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i&subset=latin-ext);", ""]);

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n* {\n    margin: 0px 0px 0px 0px;\n    padding: 0px 0px 0px 0px;\n}\n\nhtml {\n    background-size: cover;\n}\n\nbody {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    font-family: 'Open Sans', sans-serif;\n    font-size:22px;\n    font-weight: 400;\n    color: #ffffff;\n    \n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 132
// module chunks = 2